// ⛔️Generated file. Manual changes will be lost ⛔️

import {
    Operation,
    MessagingClient,
    ServiceClient,
} from '@multipass-system';
import {
    ListCatalogueRequestDto,
    ListCatalogueResponseDto,
    ResetProgressRequestDto,
    ResetProgressResponseDto,
    SyncRequestDto,
    SyncResponseDto
} from '@multipass-learning-service-dto';

export class LearningServiceOperations {

    static ListCatalogue: Operation = {
        'key': 'multipass-learning-service_ListCatalogue',
        'name': 'ListCatalogue',
        'version': '1.0.0',
        'route': '/learning-svc/catalogue',
        'method': 'POST',
    };

    static ResetProgress: Operation = {
        'key': 'multipass-learning-service_ResetProgress',
        'name': 'ResetProgress',
        'version': '1.0.0',
        'route': '/learning-svc/progress/reset',
        'method': 'POST',
    };

    static Sync: Operation = {
        'key': 'multipass-learning-service_Sync',
        'name': 'Sync',
        'version': '1.0.0',
        'route': '/learning-svc/sync',
        'method': 'POST',
    };

}

export interface LearningServiceClient extends ServiceClient {
    requestListCatalogue(request: ListCatalogueRequestDto, timeoutInMs?: number): Promise<ListCatalogueResponseDto>;
    requestResetProgress(request: ResetProgressRequestDto, timeoutInMs?: number): Promise<ResetProgressResponseDto>;
    requestSync(request: SyncRequestDto, timeoutInMs?: number): Promise<SyncResponseDto>;
}

const DefaultTimeoutInMs = 20_000;

export class LearningServiceClientImpl implements LearningServiceClient {

    constructor(private _messagingClient: MessagingClient) {}

    public requestListCatalogue(request: ListCatalogueRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<ListCatalogueResponseDto> {
        return this._messagingClient.request<ListCatalogueRequestDto, ListCatalogueResponseDto>(
            LearningServiceOperations.ListCatalogue,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestResetProgress(request: ResetProgressRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<ResetProgressResponseDto> {
        return this._messagingClient.request<ResetProgressRequestDto, ResetProgressResponseDto>(
            LearningServiceOperations.ResetProgress,
            request,
            {timeoutMs: timeoutInMs}
        );
    }

    public requestSync(request: SyncRequestDto, timeoutInMs: number = DefaultTimeoutInMs): Promise<SyncResponseDto> {
        return this._messagingClient.request<SyncRequestDto, SyncResponseDto>(
            LearningServiceOperations.Sync,
            request,
            {timeoutMs: timeoutInMs}
        );
    }
}
